/**
 * React Query cache namespace for this surface. Mirrors `WorkOrderAttachments/constants.ts` — the
 * shared surface and the field commit have to agree on the entity key.
 */
export const INVOICE_ATTACHMENTS_ENTITY_KEY = 'invoice-attachments';
/** Locale namespace holding this surface's table copy. */
export const INVOICE_ATTACHMENTS_NS = 'features.invoice_attachments.table';
export const MASS_ACTIONS_NS = 'features.invoice_attachments.mass_actions';
/**
 * Note `tab`, not `table` — a sibling of the table namespace, not a child. Deriving it as
 * `${namespace}.progress_toast` produced a `[missing ...]` string on the Building surface that a
 * green test suite could not see, which is why the shared config takes it explicitly.
 */
export const PROGRESS_TOAST_NS = 'features.invoice_attachments.tab.progress_toast';
export const EDIT_MODAL_ERRORS_NS = 'features.invoice_attachments.edit_modal.errors';
export const UPLOAD_NS = 'features.invoice_attachments.upload';
export const COMMONS_NS = 'features.commons';
/**
 * `file_access` enum values, matching `InvoiceAttachment`'s own
 * `enum :file_access, { public: 0, private: 1 }`.
 *
 * Despite the names, neither value is storage-level access control: CarrierWave is configured
 * `fog_public = true` and the direct-upload path serves through CloudFront, so both are publicly
 * readable by URL. What the value actually governs is which attachments `InvoiceMailer` attaches
 * to the invoice email and which the customer portal lists. The column copy says "Visibility" for
 * that reason — calling it "Private" in the UI would promise an enforcement that does not exist.
 */
export const FILE_ACCESS_PUBLIC = 'public';
export const FILE_ACCESS_PRIVATE = 'private';
/** Filter identity for the Visibility filter. */
export const FILE_ACCESS_FILTER_KEY = 'file_access';
/** `update_action` value `#bulk_update` switches on — matches the controller's constant. */
export const BULK_UPDATE_ACTION_FILE_ACCESS = 'file_access';
/** Finalize attribute name — the wire shape the invoice presign/finalize endpoints accept. */
export const ATTR_FILE_ACCESS = 'file_access';
/**
 * No file-type filter and no accepted-type fallback on this surface.
 *
 * Every row here is a PDF, on both paths: `AttachmentPdfUploader` declares
 * `extension_allowlist ['pdf']` so no legacy row can be anything else, and the registry pins
 * `INVOICE` to `PDF_ONLY` for the direct-upload path. A file-type filter would therefore render a
 * single option on every invoice, which reads as a broken control rather than a useful one.
 *
 * The accepted-type list is still passed down from the server rather than restated here — see
 * `InvoiceAttachmentsSurfaceProps#acceptContentTypes`.
 */
export const INVOICE_ACCEPT_FALLBACK = undefined;
